import $ from "jquery"
import _ from "underscore"
import BaseReportPDFPreviewLightboxController from "../pdf/PDFPreviewLightboxController";
import ParametersFormattingStrategy from "./ParametersFormattingStrategy"
import PDFSettingsPreview from "./PDFSettingsPreview"

const PDFPreviewLightboxController = function(){};

PDFPreviewLightboxController.prototype = _.create(BaseReportPDFPreviewLightboxController.prototype, {

    _initPdfSettingsPreview: function(elementsIdPrefix)
    {
        this.pdfSettingsPreview = new PDFSettingsPreview($(this.lightBoxEl).find(".pdfPreviewContainer"), elementsIdPrefix, this.eventNamespace).init();
    },

    createFormattingStrategy: function () {
        return new ParametersFormattingStrategy().init(
            this._getSelectorsData(),
            this.dateFormat,
            this.productSettingsValidator,
            this.reportRightsValidator
        )
    },
    
    getStore: function()
    {
        return EVAReport.Store;
    },

    _getSelectedParameters: function()
    {
        var reportParams = this.getStore().getReportParams();
        return {
            tasksConfig: reportParams.tasksConfig,
            firstGroupingLevel: reportParams.firstGroupingLevel,
            secondGroupingLevel: reportParams.secondGroupingLevel,
            thirdGroupingLevel: reportParams.thirdGroupingLevel,
            fourthGroupingLevel: reportParams.fourthGroupingLevel,
            dateParameters: {
                dateSelection : reportParams.dateSelection
            },
            customersProjectsSelection: reportParams.customersProjectsSelection,
            includeNotEstimated: reportParams.includeNotEstimated,
            includeNotStarted: reportParams.includeNotStarted
        }
    },

    _getSelectorsData: function()
    {
        var store = this.getGeneralStore();
        return {
            cpList: store.getCPList(),
            projectsWithMaIds: store.getProjectsWithMaIds(),
        };
    }
});

export default PDFPreviewLightboxController


// WEBPACK FOOTER //
// ./web/js/reports/estimatedVsActualReport/PDFPreviewLightboxController.js